import styles from "./UtilityColorField.module.scss";

interface UtilityColorFieldProps {
	label: string;
	value: string;
	onChange: (value: string) => void;
	error?: string;
}

/** Brand color entry: a swatch that opens the native picker plus a hex field. */
export function UtilityColorField({ label, value, onChange, error }: Readonly<UtilityColorFieldProps>) {
	// <input type="color"> only accepts #rrggbb, so half-typed hex keeps the last valid swatch.
	const swatchValue = /^#[0-9a-fA-F]{6}$/.test(value) ? value : "#000000";

	return (
		<div className={styles.field}>
			<span className={styles.label}>{label}</span>
			<div className={styles.control}>
				<input
					type="color"
					aria-label={`${label} swatch`}
					className={styles.swatch}
					value={swatchValue}
					onChange={event => onChange(event.target.value.toUpperCase())}
				/>
				<input
					type="text"
					aria-label={label}
					className={styles.hexInput}
					value={value}
					onChange={event => onChange(event.target.value)}
				/>
			</div>
			{error && <span className={styles.error}>{error}</span>}
		</div>
	);
}
